// @ts-nocheck
import ProgramSelect from '@jo-v2/features/JoRecommender/ProgramSelect';
import RecommenderExitStrategy from '@jo-v2/features/JoRecommender/RecommenderExitStrategy';
import SubmissionQueue from '@jo-v2/features/JoRecommender/SubmissionQueue';
import { type FC, useState } from 'react';

import type { Qualifications, VoyagerResult, VoyagerResultEnhancedSchoolData } from '@core/ts/results';

import PiiConfirmation from './PiiConfirmation';

type Props = {
  enhancedSchoolData?: VoyagerResultEnhancedSchoolData;
  results: VoyagerResult[];
  qualifications?: Qualifications;
  closePopup: () => void;
  eventingOverrides: { [key: string]: any };
};
const JoRecommender: FC<Props> = ({ results, qualifications, closePopup, eventingOverrides, enhancedSchoolData }) => {
  const [piiLeadErrors, setPiiLeadErrors] = useState<{ field: string }[]>([]);
  const [editMode, setEditMode] = useState(false);
  const [recommenderStep, setRecommenderStep] = useState('PROGRAM_SELECT');

  if (!results?.length) return null;

  const renderMapControl = {
    PROGRAM_SELECT: (
      <ProgramSelect
        setRecommenderStep={setRecommenderStep}
        results={results}
        qualifications={qualifications}
        closePopup={closePopup}
        eventingOverrides={eventingOverrides}
      />
    ),

    PII_CONFIRMATION: (
      <PiiConfirmation
        piiLeadErrors={piiLeadErrors}
        setRecommenderStep={setRecommenderStep}
        setEditMode={setEditMode}
        editMode={editMode}
      />
    ),
    SUBMISSIONS: (
      <SubmissionQueue
        setPiiLeadErrors={setPiiLeadErrors}
        piiLeadErrors={piiLeadErrors}
        setRecommenderStep={setRecommenderStep}
        closePopup={closePopup}
        setEditMode={setEditMode}
      />
    ),
    EXIT_STRATEGY: <RecommenderExitStrategy eventingOverrides={eventingOverrides} closePopup={closePopup} />,
  };

  return <div className="recommender-form">{renderMapControl[recommenderStep as keyof typeof renderMapControl]}</div>;
};

export default JoRecommender;
